import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { Box, Typography, Container, Grid,TextField, Button, Divider } from '@mui/material';

import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Import carousel styles

const PartnerLogosCarousel = () => {
  const imagesList = ["HDFC MF.png", "LIC-logo.png", "icici-mf.jpeg", "Axis_Mutual_Fund.png", "Nippon MF.png", "motilal-logo.png", "LT MF.png", "log-dsp.png", "ppfas-logo.png", "KOTAK MF.png", "mirae-mutual-fund-logo.jpg", "TATA MF.jpg", "Invesco MF.png", "birla-sun-life.png", "sbi-mf.svg" ,"QUANT NF.jpg" ]
  return (
    <Box sx={{ backgroundColor: 'white', py: 8 }}>
      <Container>
        <Typography 
                  variant="h4" 
                  component="h2" 
                  sx={{
                    fontWeight: 'bold', 
                    color: '#333', 
                    mb: 2, 
                    textAlign: { xs: 'center', md: 'left' }
                  }}
                >
                  Our Product Partners
                </Typography>
    <div className="partner-logos-carousel">
      <Carousel 
        infiniteLoop
        showThumbs={false}
        showStatus={false}
        autoPlay
        interval={2000}  // Time for each slide to show (in ms)
        transitionTime={500}  // Time for the slide transition (in ms)
        dynamicHeight={false}
        swipeable
        emulateTouch
        centerMode
        showIndicators={false}
        centerSlidePercentage={25} 
      >
        {/* Logo Images */}
        { imagesList.map((obj,i) => {
          return <div key={i}>
          <img src={`./websiteContent/logo/${obj}`} alt={`Partner ${i}`} />
        </div>
        }) }
      </Carousel>
      </div>
      </Container>
      </Box>
  );
};

export default PartnerLogosCarousel;
